'use client'

import { useSyncExternalStore } from 'react'
import {
  getActiveEditorKey,
  subscribeActiveEditor,
} from './active-editor-snapshot'

/**
 * True only when this field key is the active editor.
 * Re-renders when this key becomes active/inactive — not when other fields change.
 */
export function useEditorFieldActive(instanceKey) {
  return useSyncExternalStore(
    subscribeActiveEditor,
    () => Boolean(instanceKey) && getActiveEditorKey() === instanceKey,
    () => false,
  )
}
